export default __webpack_public_path__ + "static/media/alex-productions-extreme-sport-dubstep-im-back.4b8da756.mp3";